/* @flow */
import React, { Component, PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { InputField, GeneralTerms, SpinnerButton, GeneralError, PrivacyPolicy } from 'components';
import { UserService } from 'frilans-finans';
import Utils from 'frilans-finans/utils/utils';
import LoginBottomElement from '../login-view/tabs/login-bottom-element';

export class RegisterView extends Component {

  static propTypes = {
    show: PropTypes.string,
    handle: PropTypes.func,
    switchView: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      formValues: {
        firstName: {
          value: '',
          valid: false
        },
        lastName: {
          value: '',
          valid: false
        },
        email: {
          value: '',
          valid: false
        },
        password: {}
      },
      emailNotEqual: false,
      passwordNotEqual: false,
      showErrorWithoutBlur: false,
      hasAgreedToPrivacyPolicy: false,
      error: false,
      loading: false,
      postSuccess: false
    };

    this.callback = this.callback.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.toggleHasAgreedToPrivacyPolicy = this.toggleHasAgreedToPrivacyPolicy.bind(this);
    this.validInputs = this.validInputs.bind(this);
  }

  callback (name, values) {
    var tempFormValues = this.state.formValues;

    Object.assign(tempFormValues[name], values);
    this.setState({ formValues: tempFormValues });
  }

  validInputs () {
    return this.state.formValues.firstName.value && this.state.formValues.firstName.valid &&
      this.state.formValues.lastName.value &&this.state.formValues.lastName.valid &&
      this.state.formValues.email.value && this.state.formValues.email.valid &&
      this.state.formValues.password.value && this.state.formValues.password.valid;
  }

  registerWithEmailGtmEvent (params) {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'emailRegistration',
        'userData': {
          'email': params.email
        }
      });
    }
  }

  registerUser () {
    let params = Utils.getPostParams(this.state.formValues);

    UserService.post(params)
      .then(() => {
        this.setState({
          postSuccess: true
        });
        this.registerWithEmailGtmEvent(params);
      })
      .catch((error) => {
        let errors = UserService.getError(error);

        this.setState({
          error: true,
          loading: false,
          errorMessage: errors
        });
      });
  }

  toggleHasAgreedToPrivacyPolicy () {
    this.setState({
      hasAgreedToPrivacyPolicy: !this.state.hasAgreedToPrivacyPolicy
    });
  }

  submitForm (e) {
    e.preventDefault();

    this.setState({ showErrorWithoutBlur: true }, () => {
      if (Utils.validateInputValues(this.state.formValues)) {
        this.setState({
          loading: true
        }, this.registerUser);
      }
    });
  }

  renderPasswordError () {
    if (this.state.passwordNotEqual) {
      return (<p className='error'><Translate content='PASSWORD_NOT_EQUAL' /></p>);
    }
  }

  renderEmailError () {
    if (this.state.emailNotEqual) {
      return (<p className='error'><Translate content='EMAIL_NOT_EQUAL' /></p>);
    }
  }

  renderError () {
    if (this.state.error) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className="error" key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  renderContent () {
    if (this.state.postSuccess) {
      return (<p className='info'><Translate content='CREATE_ACCOUNT_SUCCESS_MSG' /></p>);
    }

    return (
      <div>
        <form noValidate onSubmit={this.submitForm}>

          <div className='register-input-row'>
            <InputField
              classes='register-form-field'
              type='text'
              name='firstName'
              value={this.state.formValues.firstName.value}
              placeholder={proxyCounterpart('FIRST_NAME')} callback={this.callback}
              required='true'
              minLength='2'
              errorMessage={proxyCounterpart('FIRST_NAME_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
            <InputField
              classes='register-form-field'
              type='text'
              name='lastName'
              value={this.state.formValues.lastName.value}
              placeholder={proxyCounterpart('LAST_NAME')}
              callback={this.callback}
              required='true'
              minLength='2'
              errorMessage={proxyCounterpart('LAST_NAME_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
          </div>

          <div className='register-input-row'>
            <InputField
              classes='register-form-field'
              type='email'
              validationType='email'
              name='email'
              value={this.state.formValues.email.value}
              placeholder={proxyCounterpart('EMAIL')}
              callback={this.callback}
              required='true'
              minLength='5'
              errorMessage={proxyCounterpart('EMAIL_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
          </div>

          <div className='register-input-row'>
            <InputField
              classes='register-form-field'
              type='password'
              name='password'
              placeholder={proxyCounterpart('PASSWORD')}
              callback={this.callback}
              required='true'
              minLength='12'
              validationType='passwordRegistration'
              errorMessage={proxyCounterpart('PASSWORD_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              showPasswordIcon
            />
          </div>

          <div className='register-terms-container'>
            <div className='checkbox-holder checkbox-container'>
              <input
                id='privacy-policy'
                type='checkbox'
                name='hasAgreedToPrivacyPolicy'
                onClick={this.toggleHasAgreedToPrivacyPolicy}
              />
              <label htmlFor='privacy-policy'>
                <span></span>
              </label>
              <PrivacyPolicy />
            </div>
          </div>

          <div>
            {this.renderError()}
            {this.renderEmailError()}
            {this.renderPasswordError()}
          </div>
          <SpinnerButton
            id='login-button'
            text={proxyCounterpart('CREATE_ACCOUNT')}
            loading={this.state.loading}
            disabled={!this.validInputs() || !this.state.hasAgreedToPrivacyPolicy}
            classes='btn cover' />
          <div className='pt-20'>
            <GeneralTerms />
          </div>
          <LoginBottomElement handleClick={this.props.switchView} />
        </form>
      </div>
    );
  }

  render () {
    return this.renderContent();
  }
}

export default RegisterView;



/** WEBPACK FOOTER **
 ** ./src/views/register-view/register-view.js
 **/